<app-asset-qr-approval-detail></app-asset-qr-approval-detail>


